import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {Link, useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

type MarketsContactBannerProps = {
  title?: string
}

export const MarketsContactBanner: FC<MarketsContactBannerProps> = ({title}) => {
  const {t} = useTranslation()
  const {notListedDescription, contactLinkText, contactLinkHref} =
    useTrademarkVerificationContent().markets

  return (
    <>
      <div className="banner">
        <Text variant={TextVariant.text14} fontWeight={TextFontWeight.bold} align="center">
          {title || t(notListedDescription)}
        </Text>
        <Text variant={TextVariant.text14} align="center" color={theme.palette.text.primary}>
          <Link href={contactLinkHref} legacyBehavior>
            <a className="link underline" target="_blank" rel="noopener noreferrer">
              {t(contactLinkText)}
            </a>
          </Link>
        </Text>
      </div>

      <style jsx>{`
        .banner {
          padding: ${theme.spacing[3]};
          border-radius: 12px;
          margin: ${theme.spacing[3]} 0 ${theme.spacing[5.5]};
          box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[200]};
        }
        .link {
          display: inline-block;
          margin-top: ${theme.spacing[1]};
        }
      `}</style>
    </>
  )
}
